import { render, staticRenderFns } from "./NormalSearchNav225.vue?vue&type=template&id=48d208bc&scoped=true&"
import script from "./NormalSearchNav225.vue?vue&type=script&lang=js&"
export * from "./NormalSearchNav225.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d208bc",
  null
  
)

export default component.exports